module.exports = __webpack_public_path__ + "static/media/edit.b8df0190.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/actions/edit.svg
// module id = 549
// module chunks = 0